import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  current_page: 1,
  page_size: 10,
  has_more: false,
  total_page: 0,
  total_count: 0,
  data: [],
  filters: {
    doctor: [],
    leave: [],
  },
};

export const DoctorHolidaySlice = createSlice({
  name: "DoctorHolidayReducer",
  initialState,
  reducers: {
    setDoctorHolidayList: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    setDoctorComboList: (state, action) => {
      state.filters.doctor = action.payload;
    },
    setLeaveComboList: (state, action) => {
      state.filters.leave = action.payload;
    },
  },
});

export const { setDoctorHolidayList, setDoctorComboList, setLeaveComboList } =
  DoctorHolidaySlice.actions;

export default DoctorHolidaySlice.reducer;
